<template>
  <div class="main scroll" ref="scroll">
    <div class="scroll-wrapper">
      <a-tabs default-active-key="0" @change="changeTab">
        <a-tab-pane key="0" :tab="`系统消息(未读${$store.state.systemMsg})`">
          <a-table
            :columns="columns"
            :data-source="list"
            :pagination="pagination"
          >
            <template slot="status" slot-scope="text, record">
              <div :class="record.is_read ? 'read' : 'unread'">{{ text }}</div>
            </template>
            <template slot="content"  slot-scope="text, record">
              <div @click="newsDetail(record)" style="cursor: pointer;">
                {{record.content}}
              </div>
            </template>
            <template slot="actions"  slot-scope="text, record">
              <div @click="newsDetail(record)" :class="record.is_read ? 'read' : 'unread'">
                详情
              </div>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-modal :visible="detailModal" centered title="消息详情" footer="" @cancel="detailModal = false">
      <div v-if="detail" class="content">
        <div class="type">{{detail.title}}</div>
        <div class="time">{{detail.create_time}}</div>
        <div class="info">
          {{detail.content}}
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      type: 0,
      list: [],
      pagination: false,
      detail:null,
      detailModal:false,
      columns: [
        {
          title: "时间",
          width: "120px",
          dataIndex: "create_time",
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: "类型",
          width: "140px",
          dataIndex: "title",
          scopedSlots: { customRender: "title" },
        },
        {
          title: "内容",
          dataIndex: "content",
          scopedSlots: { customRender: "content" },
        },
        {
          title: "发送老师",
          width: "100px",
          dataIndex: "teacher_name",
          scopedSlots: { customRender: "teacher_name" },
        },
        {
          title: "状态",
          width: "70px",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          width: "70px",
          dataIndex: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo", "headers"]),
  },
  created() {
    console.log(this.babyInfo)
    if (this.userInfo) {
      this.getList();
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D;
    },
    getNews(type) {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.newsCount,
        headers: { Authorization: this.$store.state.headers },
        data: {
          type: type,
          student_id: 0,
        },
      })
        .then((res) => {
          switch (type) {
            case 0:
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setSystemMsg", 0);
                return false;
              }
              this.$store.dispatch("setSystemMsg", res.data.data);
              break;
            case 1:
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setUploadMsg", 0);
                return false;
              }
              this.$store.dispatch("setUploadMsg", res.data.data);
              break;
            case 2:
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setClaimMsg", 0);
                return false;
              }
              this.$store.dispatch("setClaimMsg", res.data.data);
              break;
            case 3:
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setGrowupMsg", 0);
                return false;
              }
              this.$store.dispatch("setGrowupMsg", res.data.data);
              break;
            case "":
              if (res.data.status == 200 && !res.data.data) {
                this.$store.dispatch("setAllMsg", 0);
                return false;
              }
              this.$store.dispatch("setAllMsg", res.data.data);
              break;
            default:
              break;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    newsDetail(item) {
      this.detail = item 
      this.detailModal = true
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.newsDetail,
        headers: { Authorization: this.$store.state.headers },
        data: {
          message_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 ) {
            this.getList()
            this.getNews("");
            this.getNews(item.type);
          } 
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    getList() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.newsList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          type: this.type,
          student_id: 0,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.list = res.data.data.map((arr) => {
              arr.create_time = this.timestampToTime(arr.create_time);
              if (arr.is_read) {
                arr.status = "已读";
              } else {
                arr.status = "未读";
              }
              return arr;
            });
          } else {
            this.list = [];
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    changeTab(e) {
      console.log(e);
      this.type = e;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ant-tabs {
  margin-top: 10px;
}
.unread {
  color: #ee6f1b !important;
  cursor: pointer;
}
.read {
  color: #567eeb !important;
  cursor: pointer;
}
.content .type{
  font-size: 20px;
  font-weight: bold;
  color: #567eeb;
}
.content .time{
  font-size: 14px;
  color: #898989;
}
.content .info{
  font-size: 14px;
  color: #666;
  margin-top: 15px;
}
</style>
